import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=68afbc3a&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"
import style0 from "./verification.vue?vue&type=style&index=0&id=68afbc3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68afbc3a",
  null
  
)

export default component.exports